import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-mega-menu',
    imports: [RouterLink],
    templateUrl: './mega-menu.component.html',
    styleUrls: ['./mega-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MegaMenuComponent {
}
